
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.24545 5.54545H21L19.4727 13.1727C19.3011 14.0366 18.5351 14.6532 17.6545 14.6364H8.04545C7.1268 14.6442 6.34667 13.9654 6.22727 13.0545L4.84545 2.58182C4.72693 1.67781 3.95719 1.00138 3.04545 1H1M7.36364 21C8.36779 21 9.18182 20.186 9.18182 19.1818C9.18182 18.1777 8.36779 17.3636 7.36364 17.3636C6.35948 17.3636 5.54545 18.1777 5.54545 19.1818C5.54545 20.186 6.35948 21 7.36364 21ZM18.2727 21C19.2769 21 20.0909 20.186 20.0909 19.1818C20.0909 18.1777 19.2769 17.3636 18.2727 17.3636C17.2686 17.3636 16.4545 18.1777 16.4545 19.1818C16.4545 20.186 17.2686 21 18.2727 21Z","stroke":"#484444","stroke-width":"1.36364","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.24545 5.54545H21L19.4727 13.1727C19.3011 14.0366 18.5351 14.6532 17.6545 14.6364H8.04545C7.1268 14.6442 6.34667 13.9654 6.22727 13.0545L4.84545 2.58182C4.72693 1.67781 3.95719 1.00138 3.04545 1H1M7.36364 21C8.36779 21 9.18182 20.186 9.18182 19.1818C9.18182 18.1777 8.36779 17.3636 7.36364 17.3636C6.35948 17.3636 5.54545 18.1777 5.54545 19.1818C5.54545 20.186 6.35948 21 7.36364 21ZM18.2727 21C19.2769 21 20.0909 20.186 20.0909 19.1818C20.0909 18.1777 19.2769 17.3636 18.2727 17.3636C17.2686 17.3636 16.4545 18.1777 16.4545 19.1818C16.4545 20.186 17.2686 21 18.2727 21Z","stroke":"#484444","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    